import axios from "@configs/axios";

export const getUser = () => {
  return axios.get("/api/profile/");
};
